export default function Leaderboard({ id, walletAddress }: { id: string; walletAddress?: string }) {
  return (
    <div className="m-claim--w-full">
      <div
        data-instance={id}
        data-address={walletAddress?.toLowerCase()}
        data-widget="m-leaderboard"
      />
    </div>
  );
}
